module.exports = __webpack_public_path__ + "img/a2-s61.f16d4bb0.jpg";